<app-moneybar [moneybarData]="currentMoneybar"></app-moneybar>
